import { Dropdown, Input, Table } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import svg27 from "../../../assets/svg/svg27.svg";
import DeleteModal from "../../../components/DeleteModal"; 
import InsideHeader from "../../../components/InsideHeader"; 
import FilterModal from "./modal/FilterModal";
import svg38 from "../../../assets/svg/svg38.svg";

import MaterialIcon from "material-icons-react";
import { fetchUserMainScreen } from "../../../features/dropdown/dropdownSlice";
import { dateForHumans } from "../../../utils";
import PermissionModal from "./modal/PermissionModal ";
import AddUsersModal from "./modal/AddUsersModal";

export default function UsersTable() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { userMainScreen, loading, userMainScreenCount } = useSelector(
    (state) => state.dropdown
  );
  const { staffloading } = useSelector((state) => state.staff);

  const [searchText, setSearchText] = useState("");

  const [open, setopen] = useState(false);

  function handleCancel() {
    setopen(false);
  }
  const [filters, setFilters] = useState([]);
  const [formData, setFormData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModalFilter = () => {
    setIsModalOpen(true);
  };

  const handleClearFilters = async () => {
    await setFormData({});
    await dispatch(fetchUserMainScreen());
    await setFilters([]);
  };

  const [prodd, setProdd] = useState("");
  const [isModalOpenDelete, setIsModalOpenDelete] = useState(false);
  const [isModalOpenPermission, setIsModalOpenPermission] = useState(false);
  const showModalPermission = async () => {
    setIsModalOpenPermission(true);
  };
  const showModalDelete = async () => {
    setIsModalOpenDelete(true);
  };

  const handleDelete = async () => {
    // const res = await dispatch(
    //   deleteStaffBank({
    //     sbId_id: prodd?.sbId,
    //   })
    // );
    // if (res?.payload?.success) {
    //   await toast.success(res?.payload?.messages?.message);
    //   await fetchUserMainScreenData();
    //   await setIsModalOpenDelete(false);
    // } else {
    //   toast.error(res?.payload?.messages?.message);
    // }
  };

  const handleAdd = async () => {
    await setopen(true);
    await setProdd("");
  };

  const handleEdit = () => {
    setopen(true);
  };
  const showModalPermissions = async () => {
    showModalPermission();
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <Link
          onClick={handleEdit}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
          Edit
        </Link>
      ),
    },
    

    {
      key: "3",
      label: (
        <div
          onClick={showModalPermissions}
          className="flex  text-[16px] font-sans   !text-lightBlack"
        >
          Permissions
        </div>
      ),
    },
  ];

  
  const columns = [
    {
      title: "Personnel Number",
      dataIndex: "usrPersId",
      sorter: (a, b) => a.usrPersId.localeCompare(b.usrPersId),
    },
    {
      title: "First Name",
      dataIndex: "usrFirstName",
      sorter: (a, b) => a.usrFirstName.localeCompare(b.usrFirstName),
    },
    {
      title: "Last Name",
      dataIndex: "usrLastName",
      sorter: (a, b) => a.usrLastName.localeCompare(b.usrLastName),
    },
    {
      title: "User Name",
      dataIndex: "usrUsername",
      sorter: (a, b) => a.usrUsername.localeCompare(b.usrUsername),
    },

    {
      title: "Email Address",
      dataIndex: "usrEmail",
      sorter: (a, b) => a.usrEmail.localeCompare(b.usrEmail),
    },
    {
      title: "User Updated On",
      dataIndex: "usrUpdatedAt",
      sorter: (a, b) => a.usrUpdatedAt.localeCompare(b.usrUpdatedAt),
      render: (item) => {
        return <div>{dateForHumans(item)}</div>;
      },
    },
    {
      title: "User Created On",
      dataIndex: "usrCreatedAt",
      sorter: (a, b) => a.usrCreatedAt.localeCompare(b.usrCreatedAt),
      render: (item) => {
        return <div>{dateForHumans(item)}</div>;
      },
    },
    {
      title: "Mobile",
      dataIndex: "usrMobileNumber",
      sorter: (a, b) => a.usrMobileNumber.localeCompare(b.usrMobileNumber),
    },
    {
      title: "User On Duty",
      dataIndex: "usrOnduty",
      render:(item)=>{
        return(
          <div>{item ? "True" : 'False'}</div>
        )
      },
      sorter: (a, b) => a.usrOnduty.localeCompare(b.usrOnduty),
    },
    {
      title: "User Type",
      dataIndex: "usrType",
      sorter: (a, b) => a.usrType.localeCompare(b.usrType),
    },
    {
      title: "User Tile",
      dataIndex: "usrTitle",
      sorter: (a, b) => a.usrTitle.localeCompare(b.usrTitle),
    },
    {
      title: "Enabled",
      dataIndex: "usrEnabled",
      render:(item)=>{
        return(
          <div>{item ? "True" : 'False'}</div>
        )
      },
      sorter: (a, b) => a.usrEnabled.localeCompare(b.usrEnabled),
    },

    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchUserMainScreenData(page, size) {
    dispatch(
      fetchUserMainScreen({
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    fetchUserMainScreenData();
  }, []);

  return (
    <div className="w-full h-full overflow-y-scroll">
      <InsideHeader
        title="Users Information"
        subtitle="Manage Users within your institution"
        back={false}
      />

      <div className="bg-white rounded-[10px] mt-[1.25rem] h-full">
        <div className="flex flex-col w-full lg:px-10 px-3 ">
          <h3 className="font-[700] text-[24px] text-lightBlack dash-title mt-[1.25rem]">
            Users Details
          </h3>
          <div className="mt-5 flex lg:flex-row flex-col gap-y-5 justify-between lg:items-center items-start w-full">
            <div className="flex items-center">
              <span>
                {" "}
                <button
                  onClick={showModalFilter}
                  type="button"
                  className={`bg-transparent flex items-center gap-x-'1' ${
                    Object?.keys(formData)?.length > 0
                      ? "!text-[#5688E5]"
                      : "inherit"
                  }`}
                >
                  <MaterialIcon color="#141414" icon="filter_list" />
                  Filters
                </button>
              </span>
              {Object?.keys(formData)?.length > 0 && (
                <span className="flex items-center text-[#5688E5] cursor-pointer ml-1">
                  :{Object?.keys(formData)?.length}
                  <img src={svg38} alt="svg38" onClick={handleClearFilters} />
                </span>
              )}
            </div>
            <div className="flex lg:flex-row flex-col lg:items-center items-start lg:gap-x-10 gap-y-5">
              <div className="w-[229px]">
                <button onClick={() => handleAdd()} className="cstm-btn">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                  >
                    <path
                      d="M19.5 11H13.5V5C13.5 4.73478 13.3946 4.48043 13.2071 4.29289C13.0196 4.10536 12.7652 4 12.5 4C12.2348 4 11.9804 4.10536 11.7929 4.29289C11.6054 4.48043 11.5 4.73478 11.5 5V11H5.5C5.23478 11 4.98043 11.1054 4.79289 11.2929C4.60536 11.4804 4.5 11.7348 4.5 12C4.5 12.2652 4.60536 12.5196 4.79289 12.7071C4.98043 12.8946 5.23478 13 5.5 13H11.5V19C11.5 19.2652 11.6054 19.5196 11.7929 19.7071C11.9804 19.8946 12.2348 20 12.5 20C12.7652 20 13.0196 19.8946 13.2071 19.7071C13.3946 19.5196 13.5 19.2652 13.5 19V13H19.5C19.7652 13 20.0196 12.8946 20.2071 12.7071C20.3946 12.5196 20.5 12.2652 20.5 12C20.5 11.7348 20.3946 11.4804 20.2071 11.2929C20.0196 11.1054 19.7652 11 19.5 11Z"
                      fill="#FFCD47"
                    />
                  </svg>
                  <span className="ml-1">Add Users</span>
                </button>
              </div>
            </div>
          </div>
          <div className="dash-inner-page mt-[24px] max-w-full w-full overflow-x-auto">
            <section>
              <Table
                rowSelection={false}
                className="mt-[1.31rem] w-full"
                scroll={{
                  x: 800,
                }}
                rowKey={(record) => record?.usrId}
                columns={columns}
                dataSource={userMainScreen} 
                loading={loading}
                pagination={{
                  position: ["bottomCenter"],
                  current: pageIndex + 1,
                  total: userMainScreenCount,
                  pageSize: pageSize,
                  onChange: (page, size) => {
                    setPageIndex(page - 1);
                    setPageSize(size);
                    fetchUserMainScreenData(page - 1, size);
                  },
                  showSizeChanger: false,
                  hideOnSinglePage: true,
                }}
              />
            </section>
          </div>
        </div>
      </div>

      <DeleteModal
        isModalOpen={isModalOpenDelete}
        setIsModalOpen={setIsModalOpenDelete}
        prodd={prodd}
        handleDelete={handleDelete}
        loading={staffloading}
        content={`Are you sure you want to delete Users for ${prodd?.ppFullname} `}
        title={`Delete Users for ${prodd?.ppFullname}`}
      />

      <AddUsersModal
        handleFetchData={fetchUserMainScreenData}
        open={open}
        handleCancel={handleCancel}
        prodd={prodd}
      />
      <FilterModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        formData={formData}
        setFormData={setFormData}
        filters={filters}
        setFilters={setFilters}
      />

      <PermissionModal
        isModalOpen={isModalOpenPermission}
        setIsModalOpen={setIsModalOpenPermission}
        prodd={prodd}
      />
    </div>
  );
}
